var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPercentage = function SvgPercentage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 27",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.167 18.889a.278.278 0 1 0-.556 0 .278.278 0 0 0 .556 0m1.666 0a1.944 1.944 0 1 1-3.889 0 1.944 1.944 0 0 1 3.89 0M8.055 7.778a.278.278 0 1 0-.555 0 .278.278 0 0 0 .555 0m1.667 0a1.944 1.944 0 1 1-3.889 0 1.944 1.944 0 0 1 3.889 0M19.41 6.078a.833.833 0 1 1 1.179 1.178L7.255 20.589a.833.833 0 1 1-1.178-1.178z"
  })));
};
export default SvgPercentage;